/**
 * The URL segment the meetings screen lives at under the Clarity section: `/clarity/meetings`.
 *
 * Shared because three layers must agree on it — the application's route, the tab strip's tab id and
 * the badge entry that pairs an unseen count to that tab — and a tab whose id has drifted from the
 * route silently loses its badge, so all three read this one declaration rather than three literals.
 * `type:util` is the one layer all three may reach.
 */
export const CLARITY_MEETINGS_ROUTE_SEGMENT = 'meetings';
